export default [
  {
    path: '/pages/market/mallCouponManage',
    name: '/pages/market/mallCouponManage',
    component: () => import('@/views/market/mallCouponManage.vue')
  },
  {
    path: '/pages/market/mallCouponReceiveLog',
    name: '/pages/market/mallCouponReceiveLog',
    component: () => import('@/views/market/mallCouponReceiveLog.vue')
  },
  {
    path: '/pages/market/mallCouponUseLog',
    name: '/pages/market/mallCouponUseLog',
    component: () => import('@/views/market/mallCouponUseLog.vue')
  }
]
